module.exports = __webpack_public_path__ + "img/icon-user.9ed8ef3f.svg";